module.exports = {"TXTINS_Next":{"id":"TXTINS_Next","defaultMessage":"Volgende","track":"Next"}}